module.exports = __webpack_public_path__ + "static/media/ruler-selected.21129432.svg";